import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { AdjustmentReasonBO } from '@skylab-shared/business';
import { EventBusBase } from '@skylab-shared/core';
import { AdjustmentReasonModel } from '@skylab-shared/dataModel';

import { AdjustmentReasonRepository, AdjustmentReasonRepositoryBase } from '@skylab-angular-shared/business';
import { CommandBus, EventBus, L10n, L10nBase, RootContext, RootContextBase, Weaver, WeaverBase } from '@skylab-angular-shared/core';
import { BooleanValueAccessorDirective, ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, FocusByDirective, FormContainerComponent, TextValueAccessorDirective, ToastService, ValidateDirective, ValidationSourceDirective } from '@skylab-angular-shared/ui';

import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { DictionaryDialogComponentBase, DictionaryDialogViewModelBase } from '../dictionary-dialog-base';

export interface AdjustmentReasonDialog {
    id: number;
    version: string;
}
interface AdjustmentReasonViewModel extends DictionaryDialogViewModelBase<AdjustmentReasonBO> {
    wasDefault: boolean;
}

@Component({
    selector: 'skl-adjustment-reason-dialog',
    templateUrl: './adjustment-reason-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, ValidationSourceDirective, BooleanValueAccessorDirective, FormsModule, ValidateDirective, TextValueAccessorDirective, FocusByDirective, ButtonComponent, TranslatePipe]
})
export class AdjustmentReasonDialogComponent extends DictionaryDialogComponentBase
<
AdjustmentReasonModel,
AdjustmentReasonBO,
AdjustmentReasonRepositoryBase,
AdjustmentReasonViewModel
> {
    public constructor(
        @Inject(AdjustmentReasonRepository) adjustmentReasonRepository: AdjustmentReasonRepositoryBase,
        @Inject(RootContext) rootContext: RootContextBase,
        @Inject(Weaver) weaver: WeaverBase,
        @Inject(L10n) l10n: L10nBase,
        @Inject(EventBus) eventBus: EventBusBase,

        toastService: ToastService,
        commandBus: CommandBus,
        dialogService: DialogInsService
    ) {
        super(adjustmentReasonRepository, toastService, l10n, weaver, rootContext, commandBus, eventBus, dialogService);
    }

    protected override async prepareViewModelAsync(): Promise<void> {
        await super.prepareViewModelAsync();
        this.viewModel.wasDefault = false;
    }

    protected override async prepareDataAsync(): Promise<void> {
        await super.prepareDataAsync();
        this.viewModel.wasDefault = this.viewModel.bo.model.default;
    }
}
